import { set } from "dot-prop-immutable";

import moment from "moment";

import { compressorIsInstalled } from "./Kompressor";
import { RTC_ACTION } from "./Rtc";

/* Diese Werten werden im periodischen Datenlog gespeichert.
 * Dazu wird unter "date" noch ein Zeitstempel abgelegt.
 */
const periodic_selection = {
	ablauf: {
		master: {
			system_pressure_bar: undefined,
			load_factor_percent: undefined,
			volume_flow_m3min: undefined,
			delivery_volume_m3min: undefined,
			energy_consumption_kW: undefined
		},
		compressors: {
			cindex: undefined,
			status: undefined,
			technology: undefined,
			line_pressure_bar: undefined,
			delivery_volume_m3min: undefined,
			electrical_power_kW: undefined,
			temperature_degC: undefined
		}
	}
};

const DATALOG_RESET = "DATALOG_RESET";
const DATALOG_RAW_ARRIVED = "DATALOG_RAW_ARRIVED";
export const DATALOG_SET_XRANGE = "DATALOG_SET_XRANGE";

export const dataLogResetAction = () => ({
	type: DATALOG_RESET
});

export const dataLogRawArrived = (payload, day) => ({
	type: DATALOG_RAW_ARRIVED,
	payload,
	day
});

const dataLogSetXRangeAction = range => ({
	type: DATALOG_SET_XRANGE,
	range
});

/* Ursprünglich:
 * Für maximal 7 Tage sollen Logdaten angezeigt werden.
 *
 * wir beschränken das für den Moment mal auf 3h, da man
 * ohnehin das Fenter nicht wahlfrei bewegen kann.
 * -> und üebrlegen uns später was neues.
 */
//const backlog_limit_ms = 7 * 24 * 60 * 60 * 1000;
const backlog_limit_ms = 7 * 24 * 60 * 60 * 1000;

/* Erwarteter zeitlicher Abstand zwischen den Einträgen. 10 Sekunden sollten
 * (mit Blick auf 7 Tage Historie) gerade noch machbar sein.
 */
let sample_distance_ms = 10 * 1000;

/* Speichert die gesamte Historie der Datenwerte, die zum einen
 * aus dem Backlog-Stream kommen (alte Daten zum Beginn der Session),
 * als auch die vom laufenden System abgegriffenen Daten.
 * Gespeichert wird in einem Ringpuffer, da bei der großen Zahl von
 * Einträgen (60480 + 1) Array.prototype.push() und unshift() einfach
 * zu langsam werden.
 */
class DataLog {
	constructor() {
		/* Ein Element mehr, weil wir immer mindestens einen unbenutzten
		 * Eintrag zwischen fill_head und fill_tail brauchen.
		 */
		this.length = backlog_limit_ms / sample_distance_ms + 1;

		/* Ringpuffer: groß genug um alle erwarteten Einträge aufzunehmen.
		 * Sortierung entspricht der Reihenfolge wie die Chart-Bibliothek
		 * es erwartet: steigender Index => steigender Zeitstempel
		 */
		this.table = new Array(this.length);
		this.reset();
	}
	reset() {
		/* Index des zuletzt zugewiesenen Eintrags. Gilt allerdings nur
		 * wenn !isEmpty()
		 */
		this.fill_head = 0;

		/* Index auf "eins (zeitlich) vor" den ältesten Eintrag. Gilt
		 * allerdings nur wenn !isEmpty()
		 */
		this.fill_tail = 0;
	}
	/* private */isEmpty() {
		return this.fill_head === this.fill_tail;
	}
	/* private */rangeSize(begin, end) {
		/* begin = erstes Element 
		 * end = eins hinter letztes Element
		 */
		const diff = end - begin;
		return diff >= 0 ? diff : this.length + diff;
	}
	/* private */fillSize() {
		return this.rangeSize(this.fill_tail, this.fill_head);
	}
	/* private */nextPos(pos) {
		pos++;
		if (pos >= this.length) {
			pos = 0;
		}
		return pos;
	}
	/* private */prevPos(pos) {
		pos--;
		if (pos < 0) {
			pos = this.length - 1;
		}
		return pos;
	}
	/* public */addBacklog(values) {
		/* Backlog-Block erhalten. In diesem Array liegt der jüngste Eintrag
		 * an erster, und der älteste an letzter Position. Also genau
		 * umgekehrt wie in this.table.
		 */
		let do_add = false;
		let now;			/* Zeitpunkt aktuellste Loginformation */
		let min_backlog;	/* Zeitpunkt älteste Loginformation */
		let max_backlog;	/* Zeitpunkt gewünschte älteste Loginformation */
		if (this.isEmpty()) {
			/* Wenn noch keine Einträge vorliegen, gilt der erste Backlog-Block
			 * als Maß der Dinge und wird ohne weitere Tests übernommen.
			 */
			do_add = true;
			now = values[0].date;
			/* Ganz minimal verschieben, weil unten mit ">=" auf min_backlog
			 * geprüft wird, und wir wollen den ersten Backlog-Eintrag hier
			 * sicher übernehmen.
			 */
			min_backlog = now + 1;
			max_backlog = now - backlog_limit_ms;
		} else if (values.length > 0) {
			now = this.table[this.fill_head].date;
			let fill_last = this.nextPos(this.fill_tail);
			min_backlog = this.table[fill_last].date;
			max_backlog = now - backlog_limit_ms;

			/*
			 * min_ und max_backlog sind hier nicht auf absolute werte bezogen, sondern auf die tiefe.
			 * -> min_backlog hat den hoechsten numerischen zeitstempel,
			 * -> max_backlog hat den niedrigsten numerischen zeitstempel
			 */

			if ((values[0].date > max_backlog && values[0].date < min_backlog)
				|| (values[values.length - 1].date > max_backlog && values[values.length - 1].date < min_backlog)) {
				/* Nur dann den Backlog-Block durchgehen, wenn er einen
				 * interessanten Zeitbereich abdeckt; zumindest teilweise.
				 */
				do_add = true;
			}	
		}
		if (!do_add) {
			return false;
		}
		/*
		 * rueckwaerts laufen im array, da die ursprungsdatei ja vorwaerts sortiert ist
		 */
		for (let i = values.length - 1; i >= 0; i--) {
			let value = values[i];
			if (value.date <= max_backlog) {
				/* Aufgrund der Sortierung der Backlog-Blöcke kann die Schleife
				 * gleich abgebrochen werden.
				 */
				break;
			}
			if (this.fillSize() >= this.length - 1) {
				/* Wenn der Sender sein zeitliches Raster für die Daten nicht
				 * genau einhält, dann muss diese Beschränkung beachtet werden.
				 */
				break;
			}
			if (value.date >= min_backlog) {
				/* Kann ganz normal auftreten, wenn zwischen Anfrage des
				 * Backlog und dem Eintreffen der Blöcke bereits einige
				 * Einträge aus den laufenden Werten ermittelt werden konnten.
				 * Aufgrund der Sortierung innerhalb der Backlog-Blöcke besteht
				 * allerdings noch Hoffnung :)
				 */
				continue;
			}
			this.table[this.fill_tail] = value;
			this.fill_tail = this.prevPos(this.fill_tail);
		}
		/* Wenn mehr Daten am Anfang dazu gekommen sind, gelten für das StatusLog
		 * neue Bedingungen. Deswegen neu berechnen ...
		 */
		//state.reset(this);
		return true;
	}
	/* public */addPeriodic(value) {
		/* Ein Eintrag wurden aus Werten des laufenden Systems zusammen
		 * gestellt und soll im Log gespeichert werden.
		 */
		if (this.isEmpty()) {
			this.table[this.fill_head] = value;
			/* fill_tail muss jetzt seine korrekte Position einnehmen. */
			this.fill_tail = this.prevPos(this.fill_tail);
			/* assert fillSize() === 1 */
		}
		/* Erwartete Samplerate einhalten. */
		let required = this.table[this.fill_head].date + sample_distance_ms;
		if (value.date < required) {
			return false;
		}
		if (this.fillSize() >= this.length - 1) {
			/* Überlauf des Ringpuffers verhindern. Notwendig z.B. dann, wenn
			 * im Backlog das zeitliche Raster zu eng liegt.
			 */
			this.fill_tail = this.nextPos(this.fill_tail);
		}
		this.fill_head = this.nextPos(this.fill_head);
		this.table[this.fill_head] = value;

		/* Maximale Backlog-Zeit einhalten. */
		let max_backlog = value.date - backlog_limit_ms;
		let fill_last = this.nextPos(this.fill_tail);
		while (this.table[fill_last].date < max_backlog) {
			fill_last = this.nextPos(fill_last);
		}
		this.fill_tail = this.prevPos(fill_last);
		return true;
	}
	/* private */copyValuesArray(n, first, range_end) {
		let array = new Array(n);
		for (let pos = first, i = 0; pos !== range_end;
			pos = this.nextPos(pos), i++) {
			array[i] = this.table[pos];
		}
		return array;
	}

	/* Wert wurde einfach so mal festgelegt, entsprach der maximalen Breite
	 * der Diagrammfläche in Pixel (654.57px). Gibt für die Liniengrafiken
	 * an, wieviele Segmente maximal erzeugt werden sollen. Für die
	 * Statusgrafik wird daraus die minimale Länge eines Balkensegments
	 * (besser: minimale Zeitdifferenz) berechnet.
	 */
	static limit = 655;

	/* private */reduceValuesArray(first, last) {
		/* Es muss dezimiert werden => gewünschten zeitlichen Abstand
		 * ermitteln, immer ausreichend Einträge überspringen.
		 */
		const timediff_ms = this.table[last].date - this.table[first].date;
		const distance_ms = timediff_ms / (DataLog.limit - 1);
		let array = new Array(DataLog.limit);
		let pos_time = this.table[first].date;
		for (let pos = first, i = 0; i < DataLog.limit; i++) {
			while (this.table[pos].date < pos_time && pos !== this.fill_head) {
				pos = this.nextPos(pos);
			}
			pos_time += distance_ms;
			array[i] = this.table[pos];
		}
		return array;
	}
	/* private */findFirstBisect(date) {
		let a = this.nextPos(this.fill_tail);
		if (this.table[a].date > date) {
			/* alle bekannten Daten liegen sowieso schon innerhalb */
			return a;
		}
		let b = this.fill_head;
		if (this.table[b].date < date) {
			/* alle bekannten Daten liegen "zu weit links" */
			return null;
		}
		/* Achtung: a und b (und damit auch c) beachten den Umlauf nicht! */
		if (b < a) {
			b += this.length;
		}
		while (b - a > 1) {
			let c = Math.round((a + b) / 2);
			let index = c >= this.length ? c - this.length : c;
			if (this.table[index].date < date) {
				a = c;
			} else {
				b = c;
			}
		}
		if (a >= this.length) {
			a -= this.length;
		}
		return a;
	}
	/* privat */findLastBisect(date) {
		let b = this.fill_head;
		if (this.table[b].date < date) {
			/* alle bekannten Daten liegen sowieso schon innerhalb */
			return b;
		}
		let a = this.nextPos(this.fill_tail);
		if (this.table[a].date > date) {
			/* alle bekannten Daten liegen "zu weit rechts" */
			return null;
		}
		if (b < a) {
			b += this.length;
		}
		while (b - a > 1) {
			let c = Math.round((a + b) / 2);
			let index = c >= this.length ? c - this.length : c;
			if (this.table[index].date > date) {
				b = c;
			} else {
				a = c;
			}
		}
		if (b >= this.length) {
			b -= this.length;
		}
		return b;
	}
	/* public */genValuesArray(range) {
		/* Wird von den Diagrammen aufgerufen, um ein reduziertes Array der
		 * Werte für den darzustellenden Bereich zu erhalten.
		 */
		if (this.isEmpty()) {
			return [];
		}
		/* Anfang suchen */
		const first = this.findFirstBisect(range[0]);
		if (first === null) {
			return [];
		}
		/* Ende suchen */
		const last = this.findLastBisect(range[1]);
		if (last === null) {
			return [];
		}
		/* "range_end" zeigt auf "eins hinter" das letzte Element */
		const range_end = this.nextPos(last);
		const n = this.rangeSize(first, range_end);
		if (n <= DataLog.limit) {
			return this.copyValuesArray(n, first, range_end);
		}
		return this.reduceValuesArray(first, last);
	}
	/* public */genXRange() {
		if (this.isEmpty()) {
			return [ 0, 0 ];
		}
		let fill_last = this.nextPos(this.fill_tail);
		return [
			this.table[fill_last].date,
			this.table[this.fill_head].date
		];
	}
	/* public */genStateChanges(range) {
		if (this.isEmpty()) {
			return {
				num_compressors: 0,
				changes: []
			};
		}
		/* Von rechts (jüngere Einträge) nach links (ältere Einträge) durchgehen
		 * und Status-Wechsel erkennen. Erscheint mir geschickter als von links
		 * nach rechts zu iterieren, weil findLastBisect() verwendet werden kann.
		 * Bei "von links nach rechts" müssen auch uralte Einträge wegen dem
		 * ersten state durchgesehen werden. Ausserdem enthält das Array jetzt
		 * wirklich nur noch sichtbare Kompressoren in der gewählten Range, und
		 * nicht mehr alle Kompressoren im Log von vor 7 Tagen bis jetzt.
		 */
		let pos = this.findLastBisect(range[1]);
		if (pos === null) {
			pos = this.fill_head;
		}
		let state_changes = [];
		let states = [];
		const end = this.nextPos(this.fill_tail);
		const min_timediff = (range[1] - range[0]) / DataLog.limit;
		let date = this.table[pos].date;
		const checkCompressor = (compressor, cindex) => {
			let state = compressor && compressorIsInstalled(compressor) ?
				compressor.status : 0x10000;
			if (!states[cindex] && state !== 0x10000 && date > range[0]) {
				/* Kompressor mit diesem Index wird hier zum ersten Mal gesehen */
				states[cindex] = {
					state,
					index_of_last_change: state_changes.length
				};
				state_changes.push({
					cindex,
					state: null,
					start: null,
					end: date < range[1] ? date : range[1]
				});
			} else if (states[cindex]) {
				let last_change = state_changes[states[cindex].index_of_last_change];
				if (last_change.state === null) {
					/* Unvollständigen ersten Eintrag vervollständigen */
					last_change.state = state;
					last_change.start = date;
				} else if (last_change.state === state) {
					/* Status bleibt gleich => Startzeitpunkt verschieben */
					last_change.start = date;
				} else {
					/* Status hat gewechselt => neuen Eintrag anlegen, aber nur
					* wenn inzwischen genug Zeit vergangen ist.
					*/
					states[cindex].state = state;
					if (last_change.end - last_change.start > min_timediff) {
						states[cindex].index_of_last_change = state_changes.length;
						state_changes.push({
							cindex, state,
							start: date,
							end: last_change.start
						});
					} else {
						/* ansonsten bestehenden Eintrag umschreiben */
						last_change.state = state;
						last_change.start = date;
					}
				}
			}
		};
		while (pos !== end) {
			this.table[pos].ablauf.compressors.forEach(checkCompressor);
			if (date < range[0]) {
				/* Die Prüfung erst nach dem Hinzufügen von Änderungen machen,
				 * damit auf der linken Seite bis zur X-Achse gefüllt werden kann.
				 */
				break;
			}
			pos = this.prevPos(pos);
			date = this.table[pos].date;
		}
		/* Alle Einträge abschließen */
		states.forEach((states_item, cindex) => {
			let last_change = state_changes[states_item.index_of_last_change];
			if (last_change.start < range[0]) {
				last_change.start = range[0];
			}
			if (last_change.state === null) {
				let item = this.table[pos];
				last_change.start = item.date < range[0] ? range[0] : item.date;
				let compressor = this.table[pos].ablauf.compressors[cindex];
				last_change.state = compressor && compressorIsInstalled(compressor) ?
					compressor.status : 0x10000;
			}
		});
		return {
			num_compressors: states.filter(v => v !== undefined).length,
			changes: state_changes.reverse()
		};
	}
}

let log = new DataLog();

export const addBacklogSamples = (values, dispatch) => {
	if (log.addBacklog(values)) {
		dispatch(dataLogSetXRangeAction(log.genXRange()));
	}
	else {
		
	}
};

export const genLogValues = range => log.genValuesArray(range);

export const resetDataLog = dispatch => {
	log.reset();
	dispatch(dataLogSetXRangeAction(log.genXRange()));
};

export const genStateChanges = range => log.genStateChanges(range);

const initial_state = {
	xrange: []
};

const backlogRawToCooked = (data, day) => {
	const splitresult = String(data).split("\n")

	const result = splitresult.map((raw_item) => {
		try {
			const r_i = JSON.parse(raw_item);

			return {
				date: moment(day + " " + r_i.ts).valueOf(),
				ablauf: {
					master: {
						system_pressure_bar: r_i.sp,
						load_factor_percent: r_i.lf,
						volume_flow_m3min: r_i.vf,
						delivery_volume_m3min: r_i.dv,
						energy_consumption_kW: r_i.ec
					},
					compressors: r_i.c.map((c_i, i) => {
						const result = {
							cindex: i,
							status: 0,
							technology: 0,
							line_pressure_bar: 0,
							delivery_volume_m3min: 0,
							electrical_power_kW: 0,
							temperature_degC: 0
						};
						if (c_i !== null) {
							Object.assign(result, {
								status: c_i.s,
								technology: c_i.t,
								line_pressure_bar: c_i.lp,
								delivery_volume_m3min: c_i.dv,
								electrical_power_kW: c_i.ep,
								temperature_degC: c_i.te
							});
						}
						return result;
					})
				}
			};
		}
		catch (e) {
			// console.log("dropping malformed line " + raw_item);
		}
		return null;
	});

	return result.filter((e) => { return e !== null; });		// die malformed-lines entfernen
}

export const dataLogReducer = (state = initial_state, action) => {
	switch (action.type) {
	case DATALOG_SET_XRANGE:
		return set(state, "xrange", action.range);
	default:
		return state;
	}
};

const filterCopy = (src, dst, template) => {
	for (let prop in template) {
		if (Array.isArray(src[prop])) {
			dst[prop] = [];
			src[prop].forEach((value, index) => {
				if (Array.isArray(value)) {
					/* Array in Array geht halt noch nicht */
				} else if (typeof(value) === "object") {
					dst[prop][index] = {};
					filterCopy(value, dst[prop][index], template[prop]);
				} else {
					dst[prop][index] = value;
				}
			});
		} else if (typeof(src[prop]) === "object") {
			dst[prop] = {};
			filterCopy(src[prop], dst[prop], template[prop]);
		} else {
			dst[prop] = src[prop];
		}
	}
};

/* Es wird ausgenutzt, dass (c.a.) jede Sekunde eine "RTC" Action vom Server
 * geschickt wird. In diesen Momenten soll der aktuelle Zustand (der zu
 * loggenden Daten) entweder gespeichert werden (für die anzuzeigenden
 * Tabellen, oder bei einer Änderung gespeichert werden (für die Status-Anzeige
 * der Kompressoren). Wenn keine RTC-Action kommt, dann muss hier auch nichts
 * gemacht werden, weil dann wohl auch keine neuen Daten vorliegen, oder?
 * 
 * Es handelt sich hier um eine Redux-Middleware.
 */
export const dataLogMiddleware = store => next => action => {
	switch(action.type) {
		case RTC_ACTION:
			let state = store.getState();
			let values = { date: new Date(action.date).getTime() };
			filterCopy(state, values, periodic_selection);
			if (log.addPeriodic(values)) {
				store.dispatch(dataLogSetXRangeAction(log.genXRange()));
			}
			return next(action);
		case DATALOG_RAW_ARRIVED:
			addBacklogSamples(backlogRawToCooked(action.payload, action.day), store.dispatch);
			return next(action);
		default:
			break;
	}
	return next(action);
};
